<template>
  <div>
    <new-staff-dialog :state="createState" />
    <div class="d-flex justify-space-between align-center pa-4 pa-md-2">
      <div>
        <Breadcrumbs headline="Nhân viên" :link="[{ text: 'Nhân viên', to: '../staffs' }]" />
      </div>

      <div>
        <v-btn medium color="primary" @click="createState = !createState">
          <v-icon left>add</v-icon>
          <span>{{ titleBtn }}</span>
        </v-btn>
      </div>
    </div>

    <v-card class="pa-2 pa-md-2 mx-md-2">
      <v-data-table
        @click:row="onRowClick"
        item-key="id"
        :headers="headers"
        :items="members"
        :search="search"
        :loading="isLoading"
        dense
      >
        <template v-slot:top>
          <v-row no-gutters>
            <v-col class="pa-0" cols="10" md="8">
              <staff-filter @onFilterChanged="refresh"> </staff-filter>
            </v-col>

            <v-col cols="2" md="4" class="text-right pa-0">
              <setting-table-header :default-headers="originHeaders" @change="headers = $event" />
              <KebapMenu v-if="!$vuetify.breakpoint.xs">
                <v-list>
                  <v-list-item>
                    <export-excel :custom-header="headers" api="/staff/" />
                  </v-list-item>
                </v-list>
              </KebapMenu>
            </v-col>
          </v-row>
        </template>

        <template v-slot:[`item.name`]="{ item }">
          <user-item :data="item"></user-item>
        </template>

        <template v-slot:[`item.role.name`]="{ item }">
          <div class="staff-department">{{ item.department.title }}</div>
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <v-chip v-if="item.status == 'active'" small label :color="getColor(item.status)" dark>{{
            'Hoạt động'
          }}</v-chip>
          <v-chip v-else small label :color="getColor(item.status)" dark>{{ 'Khóa' }}</v-chip>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <staff-list-actions :item="item"></staff-list-actions>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import StaffListActions from '@/modules/staff/StaffListActions'
import UserItem from '@/modules/user/UserItem'
import StaffFilter from '@/modules/staff/StaffFilter'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import NewStaffDialog from '@/modules/staff/NewStaffDialog'
import KebapMenu from '@/components/basic/menu/KebapMenu.vue'
import SettingTableHeader from '@/components/basic/table/SettingHeaders'
import ExportExcel from '@/components/basic/ExportExcel'
const originHeaders = [
  { text: 'Tên', value: 'name', align: 'left', sortable: false, show: true },
  { text: 'Mã nhân viên', value: 'code', align: 'left', sortable: false, show: true },
  { text: 'Email', value: 'email', align: 'left', sortable: false, show: true },
  {
    text: 'Số Điện Thoại',
    value: 'phone',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Trạng Thái',
    value: 'status',
    align: 'left',
    sortable: false,
    show: true
  },
  { text: 'Hành động', value: 'actions', show: true, sortable: false }
]

export default {
  components: {
    UserItem,
    StaffListActions,
    StaffFilter,
    Breadcrumbs,
    NewStaffDialog,
    KebapMenu,
    SettingTableHeader,
    ExportExcel
  },
  props: {
    role: String
  },
  data() {
    return {
      headers: [],
      originHeaders: originHeaders,
      draw: false,
      search: '',
      status: null,
      range: { from: null, to: null },
      previewUserId: null,
      ready: false,
      isLoading: false,
      createState: false,
      chipLabel: ''
    }
  },
  created() {
    this.isLoading = true
    this.fetchStaffsCount()
    this.fetchStaffs('?department=' + this.department.id).then(() => {
      this.isLoading = false
    })
  },
  computed: {
    ...mapState('staff', ['staffs', 'count', 'staff']),
    ...mapState('app', ['department']),
    members() {
      return this.staffs
    },
    titleBtn() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return 'Thêm'
        default:
          return 'Thêm Nhân Viên'
      }
    },
    filters() {
      return [{ key: 'block', value: this.status }]
    }
  },
  methods: {
    ...mapActions('staff', [
      'fetchStaffs',
      'fetchStaffsCount',
      'setStaff',
      'setStaffs',
      'updateStaffs'
    ]),
    onRowClick(item) {
      this.$router.push(`staff/${item.id}`)
    },
    updateDraw(draw) {
      this.draw = draw
    },
    async preview(user) {
      if (!user) return
      this.$refs.template.preview()
      this.previewUserId = user.id
    },
    getColor(status) {
      if (status === 'active') return 'green'
      else return 'red'
    },
    refresh(query) {
      this.isLoading = true

      this.fetchStaffs('?department=' + this.department.id + '&' + query).then(() => {
        this.isLoading = false
      })
    }
    // }
  }
}
</script>

<style scoped>
.staff-department {
  white-space: nowrap;
}
</style>
